<!-- eslint-disable @angular-eslint/template/elements-content -->
<div class="p-4 sm:p-6 space-y-5">
  <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
    <div>
      <h1 class="text-2xl font-bold text-gray-900 dark:text-white">Arizalar</h1>
      <p class="mt-1 text-sm text-gray-500 dark:text-gray-400">
        Landing page orqali kelgan mijoz so'rovlari.
      </p>
    </div>
    <button
      (click)="load()"
      class="inline-flex items-center justify-center gap-2 rounded-lg border border-gray-300 px-3 py-2 text-sm text-gray-700 hover:bg-gray-50 dark:border-gray-700 dark:text-gray-200 dark:hover:bg-gray-800"
    >
      <lucide-icon [img]="RefreshCw" class="h-4 w-4"></lucide-icon>
      Yangilash
    </button>
  </div>

  <div
    class="flex flex-col gap-3 rounded-xl border border-gray-200 bg-white p-3 dark:border-gray-700 dark:bg-gray-900 sm:flex-row"
  >
    <div class="relative flex-1">
      <lucide-icon
        [img]="Search"
        class="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400"
      ></lucide-icon>
      <input
        type="text"
        class="w-full rounded-lg border border-gray-300 bg-white py-2 pl-9 pr-3 text-sm text-gray-900 outline-none focus:ring-2 focus:ring-green-500 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
        placeholder="Ism, telefon, yo'nalish..."
        (input)="onSearch($any($event.target).value)"
      />
    </div>
    <select
      class="rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 outline-none focus:ring-2 focus:ring-green-500 dark:border-gray-700 dark:bg-gray-800 dark:text-white"
      [ngModel]="status()"
      (ngModelChange)="setStatus($event)"
    >
      <option value="">Barcha statuslar</option>
      @for (s of statuses; track s) {
        <option [value]="s">{{ s }}</option>
      }
    </select>
  </div>

  <div
    class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-900"
  >
    <p-table
      [value]="applications()"
      [loading]="loading()"
      [paginator]="true"
      [rows]="pageSize"
      [totalRecords]="total()"
      [lazy]="true"
      (onLazyLoad)="page.set(($event.first ?? 0) / pageSize + 1); load()"
      responsiveLayout="scroll"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Mijoz</th>
          <th>Do'kon</th>
          <th>Yo'nalish</th>
          <th>Status</th>
          <th>Sana</th>
          <th class="w-16"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <div class="font-medium text-gray-900 dark:text-white">{{ item.fullName }}</div>
            <div class="text-xs text-gray-500">{{ item.phoneNumber }}</div>
          </td>
          <td>{{ item.companyName || '-' }}</td>
          <td>{{ item.businessType }}</td>
          <td><p-tag [value]="item.status" [severity]="severity(item.status)" /></td>
          <td class="text-sm text-gray-500">{{ formatDate(item.createdAt) }}</td>
          <td>
            <button
              (click)="openEdit(item)"
              class="rounded-md border border-gray-300 p-1.5 text-gray-600 hover:bg-gray-100 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800"
              title="Tahrirlash"
            >
              <lucide-icon [img]="Edit" class="h-4 w-4"></lucide-icon>
            </button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6" class="py-10 text-center text-gray-500">Arizalar yo'q.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog
  header="Arizani tahrirlash"
  [visible]="dialogOpen()"
  (visibleChange)="dialogOpen.set($event)"
  [modal]="true"
  [style]="{ width: 'min(92vw, 34rem)' }"
>
  <form [formGroup]="form" (ngSubmit)="save()" class="space-y-4">
    @if (error()) {
      <div class="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700">
        {{ error() }}
      </div>
    }
    <div class="grid gap-3 sm:grid-cols-2">
      <input
        formControlName="fullName"
        class="rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
        placeholder="Ism"
      />
      <input
        formControlName="phoneNumber"
        class="rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
        placeholder="Telefon"
      />
      <input
        formControlName="companyName"
        class="rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
        placeholder="Do'kon"
      />
      <input
        formControlName="businessType"
        class="rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white"
        placeholder="Yo'nalish"
      />
      <select
        formControlName="status"
        class="rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white sm:col-span-2"
      >
        @for (s of statuses; track s) {
          <option [value]="s">{{ s }}</option>
        }
      </select>
      <textarea
        formControlName="notes"
        class="min-h-24 rounded-lg border border-gray-300 px-3 py-2 text-sm dark:border-gray-700 dark:bg-gray-800 dark:text-white sm:col-span-2"
        placeholder="Izoh"
      ></textarea>
    </div>
    <div class="flex justify-end gap-2">
      <button
        type="button"
        pButton
        class="p-button-text"
        label="Bekor qilish"
        (click)="dialogOpen.set(false)"
      ></button>
      <button
        type="submit"
        pButton
        label="Saqlash"
        [loading]="submitting()"
        [disabled]="form.invalid"
      ></button>
    </div>
  </form>
</p-dialog>
